/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkReport {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkReport.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkReport>): WellArchitectedFrameworkReport {
        let obj = Object.assign(new WellArchitectedFrameworkReport(), model);
        WellArchitectedFrameworkReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkReport>): WellArchitectedFrameworkReport {
        if (!model) return null;
        return WellArchitectedFrameworkReport.newInstance(<WellArchitectedFrameworkReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkReport) {
        if (!obj) return;

        models.WellArchitectedFrameworkReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkReport): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.triggered_at === "string") {
            this.triggered_at = new Date(<string><any>this.triggered_at);
        }
        if (typeof this.completed_at === "string") {
            this.completed_at = new Date(<string><any>this.completed_at);
        }
        if (this.report_configuration) {
            models.ReportConfigurationForAssessmentRun.fixupPrototype(this.report_configuration);
        }
        if (this.background_job) {
            models.RecordIdentity.fixupPrototype(this.background_job);
        }
    }

    /**
     * Unique ID for the report
     */
    sys_id: string;

    /**
     * ID of the user who requested the report
     */
    user_id: string;

    /**
     * Report configuration to generate report
     */
    report_configuration: models.ReportConfigurationForAssessmentRun;

    /**
     * Schedule ID of which the report to be generated
     */
    schedule_id: string;

    email_recipients: Array<string>;

    /**
     * Identity of the background job used to generate the report. null if the job has completed
     */
    background_job: models.RecordIdentity;

    /**
     * ID of the attachment where the report contents are stored. This will be null until the report has been successfully generated
     */
    attachment_id: string;

    /**
     * Reason for report generation failure
     */
    failure_message: string;

    /**
     * Status of the report generation
     */
    status: models.AssessmentRunReportStatus;

    /**
     * TimeStamp when assessment run report generation was triggered
     */
    triggered_at: Date;

    /**
     * TimeStamp when assessment run report generation was completed
     */
    completed_at: Date;

}
